<template>
  <div id="app">
    <el-row style="max-width: 630px; margin: 5px auto;" :gutter="5" v-for="(num, index) in nums" :key="index + 'num'">
      <el-col :span="8" v-for="(order, idx) in orders" :key="idx + 'order'">
        <el-button style="width: 100%; margin-left: 0px !important;" type="info" plain @click="inputNumber((index * 3) + order)">{{(index * 3) + order}}</el-button>
      </el-col>
    </el-row>
    <!-- 確認清除鍵 -->
    <el-row style="max-width: 630px; margin: 5px auto;" :gutter="5">
      <el-col :span="8">
        <el-button style="width: 100%; margin-left: 0px !important;" type="danger" plain @click="clear">{{ $t('Store.clear') }}</el-button>
      </el-col>
      <el-col :span="8">
        <el-button style="width: 100%; margin-left: 0px !important;" type="info" plain @click="inputNumber('0')">0</el-button>
      </el-col>
      <el-col :span="8">
        <el-button style="width: 100%; margin-left: 0px !important;" type="info" plain @click="inputNumber('.')">.</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  data() {
    return {
      nums: 3,
      orders: 3,
    }
  },
  props: ['type'],
  methods: {
    inputNumber(num) {
      this.$emit('addNum', num);
    },
    clear() {
      this.$emit('clear', '');
    }
  }
}
</script>